import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import classes from '@nerdwallet/base-styles/classes';
import { ElementImpression } from '@nerdwallet/nw-client-lib/tracking';
import { Title, Body } from '@nerdwallet/react-typography';
import { Impression as BedrockImpression } from '@nerdwallet/analytics/react/impression';
import { CenteredContainer } from '@nerdwallet/react-layout';

import HeroNav from './hero-nav';

import { heroNavContent } from '../../lib/front-page-content';

const Hero = ({ content, header, showBackgroundColor }) => (
  <BedrockImpression eventType="element_impression" entityName="hero_container">
    <ElementImpression
      elementDomType="section"
      elementName="Hero"
      id="hero-container"
    >
      <CenteredContainer className="hero-nav">
        <section className={classNames(['hero-nav__section'])}>
          <div
            className={classNames([
              'hero-nav__content',
              { 'hero-nav__background': showBackgroundColor },
              classes('display-flex'),
              classes('flex-direction-column'),
              classes('justify-content-center'),
              classes('padding-horizontal-4'),
            ])}
          >
            <Title
              size="x-large"
              className={classNames([
                'hero-nav__header',
                classes('text-align-center'),
                classes('chronicle-display'),
                classes('margin-bottom-3'),
              ])}
            >
              {header}
            </Title>
            <Body
              size="large"
              className={classNames([
                'hero-nav__subtitle',
                classes('text-align-center'),
                classes('type-3'),
                classes('margin-horizontal-auto'),
              ])}
            >
              {content}
            </Body>
          </div>
          <HeroNav {...heroNavContent} />
        </section>
      </CenteredContainer>
    </ElementImpression>
  </BedrockImpression>
);

Hero.propTypes = {
  content: PropTypes.string,
  header: PropTypes.string,
  showBackgroundColor: PropTypes.bool,
};

Hero.displayName = 'Hero';

export default Hero;
